import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import {
  adminLogin as apiAdminLogin,
  getAdminToken,
  setAdminToken,
} from "@/lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => getAdminToken());

  const login = useCallback(async (password) => {
    const { token: nextToken } = await apiAdminLogin(password);
    setAdminToken(nextToken);
    setToken(nextToken);
    return nextToken;
  }, []);

  const logout = useCallback(() => {
    setAdminToken("");
    setToken("");
  }, []);

  const value = useMemo(
    () => ({ token, isAuthed: Boolean(token), login, logout }),
    [token, login, logout]
  );

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) {
    throw new Error("useAdminAuth must be used within an AdminAuthProvider");
  }
  return ctx;
}

export default AdminAuthContext;
